export default __webpack_public_path__ + "music.62d30ec2.jpeg";